// ★ PC-4 — "SEM PRÓXIMO CONTATO" no Funil e na Lista — puro.
//
// A pergunta do filtro é "este lead está sem NINGUÉM cuidando?" (decisão do dono, 18/out/2026,
// `docs/medicao-pc4-filtro-funil.md` §2): conta QUALQUER tarefa aberta do lead, de qualquer
// pessoa — o "por pessoa" já é o cartão de Próximos contatos (`produtividade/placar.js`).
//
// ⚠ A régua NÃO é a do cartão, de propósito: aqui entra `nao_compareceu`, não há janela de 4
// dias (vale o período da barra) e a aberta é do LEAD, não da pessoa.

import { ehEncerrado } from '@/leads/encerrados';
import { importadoSemAtividade } from '@/leads/regras';

export const ETAPAS_SEM_PROXIMO_CONTATO = ['nao_agendou', 'nao_compareceu', 'nao_fechou'];

/**
 * Os ids dos leads com pelo menos uma tarefa ABERTA, de qualquer responsável e com qualquer
 * data (uma aberta só no futuro é próximo contato marcado). Só `concluida === false` estrito
 * conta — é o que a consulta de `ouvirProximosContatos` pede ao servidor.
 */
export const leadsComTarefaAberta = (tarefas = []) =>
  new Set((tarefas ?? []).filter((t) => t?.leadId && t.concluida === false).map((t) => t.leadId));

/**
 * O lead está numa das 3 etapas, não está encerrado, não é importado que ninguém tocou
 * (decisão 2: o acervo da planilha não infla o número) e não tem nenhuma aberta.
 */
export const semProximoContato = (lead, comAberta) =>
  ETAPAS_SEM_PROXIMO_CONTATO.includes(lead?.etapa)
  && !ehEncerrado(lead)
  && !importadoSemAtividade(lead)
  && !comAberta.has(lead.id);
